



































































import { FALL_BACK_TYPE_ENUM, TRAFFIC_FALL_BACK_TYPES } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { Message } from 'byted-vui';

const name = 'ttam-creative-deeplink-fallback-type';
export default defineComponent({
  name,
  props: {
    value: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const _value = computed({
      get: () => (props.value === FALL_BACK_TYPE_ENUM.none ? FALL_BACK_TYPE_ENUM.fallbackApp : props.value),
      set: val => {
        emit('change', val);
        emit('input', val);
      },
    });
    const isShowPopover = ref(false);

    const handleShowPopover = () => {
      isShowPopover.value = true;
    };

    const handleHidePopover = () => {
      isShowPopover.value = false;
    };

    const handleConfirmFallbackType = () => {
      if (_value.value === 1) {
        _value.value = 1;
      } else {
        _value.value = 2;
      }

      handleHidePopover();
      Message.success(i18n.t('module_ad_deeplink_fallback_type_update_message') as string);
    };

    return {
      name,
      isShowPopover,
      _value,
      TRAFFIC_FALL_BACK_TYPES,
      handleShowPopover,
      handleHidePopover,
      handleConfirmFallbackType,
    };
  },
});
